// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b6102fcf","453":"e5ff1773"}[chunkId] + ".chunk.js";
};